import React, { useCallback, useLayoutEffect, useRef } from "react";

/**
 * Textarea that grows vertically to fit its content. Keeps the CSS min-height
 * as a floor so short placeholders don't collapse.
 */
const AutoResizeTextarea = ({ value, onChange, className = "", ...props }) => {
  const ref = useRef(null);

  const resize = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    const min = parseFloat(getComputedStyle(el).minHeight) || 0;
    el.style.height = `${Math.max(el.scrollHeight, min)}px`;
  }, []);

  useLayoutEffect(() => {
    resize();
  }, [value, resize]);

  return (
    <textarea
      ref={ref}
      value={value}
      className={className}
      onChange={(e) => {
        onChange?.(e);
        resize();
      }}
      {...props}
    />
  );
};

export default AutoResizeTextarea;
